import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles({
  heading: {
    fontSize: 24,
    lineHeight: '28px',
    fontWeight: 'bold'
  },
  subheading: {
    fontSize: 18,
    fontWeight: 'bold',
    marginTop: 0,
    marginBottom: 10
  },
  paragraph: {
    marginTop: 0,
    marginBottom: 3
  },
  submitButton: {
    backgroundColor: '#4A9251',
    border: '1px solid #000000',
    borderRadius: 5,
    color: 'white'
  },
  formButton: {
    width: '100%',
    background: '#6271CB',
    color: 'white',
    borderRadius: 5,
    display: 'block',
    textDecoration: 'none',
    textAlign: 'center',
    paddingTop: 10,
    paddingBottom: 10,
    marginBottom: 7
  }
})

export default useStyles;